export const SET_FEEDBACK_TAB = 'SET_FEEDBACK_TAB';
export const GET_FEEDBACK_RECORDS = 'GET_FEEDBACK_RECORDS';
export const SET_FEEDBACK_RECORDS = 'SET_FEEDBACK_RECORDS';
export const GET_FEEDBACK_QUESTION_TYPES = 'GET_FEEDBACK_QUESTION_TYPES'; // 问题类型
export const SET_FEEDBACK_QUESTION_TYPES = 'SET_FEEDBACK_QUESTION_TYPES';
export const SET_FEEDBACK_TASK = 'SET_FEEDBACK_TASK';
export const FEEDBACK_QUESTION = [
  {
    name: 'hotIssue',
    text: '热门问题',
    child: [
      {
        name: 'download',
        text: '应用商店购买的游戏或成品号如何下载或兑换？',
        desc:
          '您好，售卖商品为steam国区激活码（需要在steam上进行激活），具体操作过程请通过购买页面下拉进行查看。如有疑问，请联系应用商店游戏客服企业QQ：800182717',
      },
      {
        name: 'refund',
        text: '购买联想版软件会员如何退费？',
        desc:
          '您好，如果购买的软件有标注“无忧退”的标签，您可以通过应用商店昵称处进入“订单中心”在订单中心页面申请退费。（备注：仅限首次购买并且在购买后7天内）',
      },
      {
        name: 'invoice',
        text: '购买联想版软件会员如何开具发票？',
        desc:
          '您好，关于您反馈的购买软件会员发票问题，请您提供：支付订单截图、发票抬头、及发票快递信息（暂无电子发票，仅支持快递）联系我们客服QQ：2881414005协助您进行开具',
      },
      {
        name: 'nounload',
        text: '软件无法进行卸载',
        desc:
          '您好，请您通过我的软件点击卸载按钮尝试。如无法正常弹出卸载程序，请通过商店搜索第三方卸载工具“geekuninstaller”在应用列表中右键操作强制删除尝试一下。如无法解决问题，请您联系工作人员QQ：2881414005',
      },
      {
        name: 'failunload',
        text: '下载任务列表显示“下载失败”',
        desc:
          '请您查看应用商店版本是否低于8.5版本，如低于8.5版本请您通过浏览器打开lestore.lenovo.com下载安装最新版本商店。如高于8.5版本依然无法下载，请在右上角设置中心修改下载路径尝试。如依然不行，请联系工作人员QQ：2881414005',
      },
      {
        name: 'uninstall',
        text: '下载完成后无法安装',
        desc:
          '请通过应用商店右上角设置中心打开下载目录，找到对应安装包进行双击运行尝试。如无法正常弹出安装界面，请您查看电脑上是否有安装“火绒安全”、“金山毒霸”等杀毒软件限制了安装程序弹出，请您取消安装拦截或退出此类软件尝试。如依然不行，请联系工作人员QQ：2881414005',
      },
      {
        name: 'reading',
        text: '下载任务列表显示“准备中”',
        desc:
          '您好，下载电脑直装（安卓类）软件需要联想模拟器提供安卓运行环境，请您等待联想模拟器安装完成后再进行安卓下载任务，如依然不行请联系客服QQ：2881414005',
      },
      {
        name: 'readingcancellation',
        text: '下载任务列表“准备中”任务无法取消',
        desc:
          '您好，下载准备中的任务是在准备安卓运行环境，请您等待联想模拟器安装完毕后再将下载任务完成后进行删除。如一直处于准备中状态，请检查联想模拟器是否能正常启动运行。',
      },
      // {
      //   name: 'downloadcancellation',
      //   text: '下载任务列表显示“下载失败”',
      //   desc:
      //     '请您查看应用商店版本是否低于8.5版本，如低于8.5版本请您通过浏览器打开lestore.lenovo.com下载安装最新版本商店。如高于8.5版本依然无法下载，请在右上角设置中心修改下载路径尝试。',
      // },
      // {
      //   name: 'noinstall',
      //   text: '下载完成后无法安装',
      //   desc:
      //     '请通过应用商店右上角设置中心打开下载目录，找到对应安装包进行双击运行尝试。如无法正常弹出安装界面，请您查看电脑上是否有安装“火绒安全”、“金山毒霸”等杀毒软件限制了安装弹出，请您退出这类软件尝试。',
      // },
      {
        name: 'installway',
        text: '安装路径相关问题',
        desc:
          '您好，软件安装路径一般情况下可以在安装界面通过“自定义安装”或“高级设置”来选择安装路径。如是快装软件会安装到快装设置路径下，您也可以关闭快装功能通过手动安装设置安装路径。',
      },
      {
        name: 'messageclose',
        text: '应用商店各种消息提醒关闭方式',
        desc: '您好，您可以进入商店右上角设置中心内下拉在更多设置中进行取消。',
      },
      // {
      //   name: 'open',
      //   text: '软件删除后依然显示“打开”，卸载提示找不到文件',
      //   desc:
      //     '关于您所述的情况可能是因为直接删除的文件夹而没有清理注册表信息导致的，请您通过软件商店搜索下载geekuninstaller工具，在该工具中找到您所述的软件右键执行“强制删除”操作来清理注册表信息，清理完毕后重启软件商店尝试',
      // },
      {
        name: 'conceal',
        text: '电脑总是自动下载软件并在隐藏托盘中出现广告',
        desc:
          '软件商店是不会自动下载安装软件和弹出垃圾广告的，该情况可能是电脑中存在其他流氓软件的恶意行为，建议您使用杀毒工具对电脑进行全面检查或重置系统尝试',
      },
      // {
      //   name: 'start',
      //   text: '无法下载软件，启动时提示“下载失败”',
      //   desc:
      //     '您好，如任务栏显示下载失败，请您使用浏览器打开lestore.lenovo.com下载最新版本应用商店重新安装尝试',
      // },
      // {
      //   name: 'fail',
      //   text: '无法下载软件，提示创建文件失败或下载速度为0',
      //   desc:
      //     '麻烦您在软件商店右上角设置中心内将下载路径修改至其他盘符试试是否可以下载。如依然无法下载请您打开控制面板，点击右上角类别切换到小图标，点击windows防火墙将防火墙关闭后再打开尝试。如依然无法下载 请联系客服QQ：2881414005',
      // },
      // {
      //   name: 'loading',
      //   text: '无法下载软件，任务列表显示“等待中”',
      //   desc:
      //     '您好，请您使用浏览器打开lestore.lenovo.com下载最新版本应用商店进行安装，安装后尝试是否可以下载，如依然无法下载请联系我们客服QQ：2881414005',
      // },
      // {
      //   name: 'reading',
      //   text: '下载安卓类软件长时间显示“准备中”',
      //   desc:
      //     '您好，下载安装安卓类软件需要需要联想模拟器提供安卓运行环境，如果您的联想模拟器无法正常运行可能会出现卡在“准备中”的状态。请您卸载联想模拟器重新安装尝试一下，如依然不行请联系客服QQ：2881414005',
      // },
      // {
      //   name: 'downloadBtn',
      //   text: '下载进度到100%以后又变成了“安装”或“升级”按钮',
      //   desc:
      //     '请确认本地是否有安装火绒？请打开火绒安全—防护中心—系统防护—软件安装拦截进行关闭后尝试，如依然无法安装请联系客服QQ：2881414005',
      // },
      // {
      //   name: 'longTime',
      //   text: '下载完成后长时间显示“安装中”',
      //   desc:
      //     '您好，请您查看是否弹出了安装界面以及任务管理器中是否有安装进程在运行中，请关闭进程通过下载路径重新运行安装尝试。如依然无法安装，请联系我们客服QQ2881414005',
      // },
      {
        name: 'unableLink',
        text: '打开软件商店后无法加载内容',
        desc:
          '请您更换网络尝试一下，例如使用手机热点尝试是否能加载。如依然无法正常运行 请联系客服QQ：2881414005。',
      },
    ],
  },
  {
    name: 'downloadQuestion',
    text: '下载问题',
    child: [
      {
        name: 'sync',
        text: '应用商店可以同时下载几个软件？',
        desc: '目前应用商店没有任务数量限制，暂时也无法设置任务数量。',
      },
      {
        name: 'cancel',
        text: '如何取消下载中的任务？',
        desc: '您可以点击应用商店右上角“下载任务管理器”可以取消正在下载中的任务。',
      },
      {
        name: 'package',
        text: '下载的软件安装包存放在哪里？',
        desc:
          '请您点击应用商店右上角“菜单栏”进入“设置中心”查看下载路径，点击“打开”可以直接打开安装包存放文件夹。',
      },
      {
        name: 'path',
        text: '下载路径是否可以修改？',
        desc:
          '下载路径可以修改。请通过“设置中心”进行修改。待修改完毕后点击确定进行保存。\n备注：路径设置中不可包含特殊符号',
      },
      {
        name: 'delete',
        text: '下载完成后是否可以自动删除安装包？',
        desc:
          '您可以通过 "设置中心" 开启安装包清理功能，开启该功能后安装包会在下载完成7天后进行删除，无需您手动清理。',
      },
      {
        name: 'delay',
        text: '下载速度很慢，如何解决？',
        desc:
          '应用商店下载速度取决于您的本地网络和我们服务器的连接状态有关，建议您可以重启路由器或更换网络尝试一下。',
      },
    ],
  },
  {
    name: 'download',
    text: '安装问题',
    child: [
      {
        name: 'path',
        text: '应用商店如何设置软件安装路径？',
        desc:
          '普通软件当前不支持设置安装路径，您可以在该软件安装器界面通过“自定义安装”或“高级设置”来选择安装路径。',
      },
      {
        name: 'feature',
        text: '快装功能介绍',
        desc:
          '部分软件支持快装功能（即静默安装），您可以通过右上角菜单进入“设置中心”开启快装功能并设置快装软件的安装路径。支持快装功能软件会在安装按钮处显示为“快装”。',
      },
      {
        name: 'file',
        text: '快装软件未安装到设置快装路径的文件夹内',
        desc: '如您遇到上述情况，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'fail',
        text: '安装界面显示安装失败',
        desc: '如您出现安装失败问题，请您通过“我要反馈”提交提供软件名称及版本，我们会核实处理。',
      },
      {
        name: 'path_1',
        text: '已经关闭快装功能为什么还是安装到C盘',
        desc:
          '您好，如无法设置安装路径或直接安装到C盘，请您通过“我要反馈”提交提供软件名称及版本，我们会核实处理。',
      },
      {
        name: 'simulator',
        text: '安装软件一直显示“准备中”或“正在为您准备模拟器环境”',
        desc:
          '您好，如果您下载的是安卓版本应用或游戏，需要先安装联想模拟器哦。请您运行联想模拟器查看是否可以正常打开，如无法正常启动模拟器，请您卸载联想模拟器后重新安装',
      },
    ],
  },
  {
    name: 'update',
    text: '升级问题',
    child: [
      {
        name: 'how',
        text: '如何升级软件？',
        desc:
          '您可点击应用商店左侧导航“软件升级”，如存在可升级软件会显示在右侧列表中，您可以点击全部升级或单个软件升级。',
      },
      {
        name: 'ignore',
        text: '如何忽略升级软件？',
        desc:
          '在可升级软件列表中将鼠标移至软件所在位置会出现“忽略”按钮，点击后即可忽略此次版本升级。',
      },
      {
        name: 'showagin',
        text: '已忽略的升级软件如何再次显示出来？',
        desc: '在软件升级列表点击“已忽略软件”可以进行恢复升级或忽略所有版本操作。',
      },
      {
        name: 'number',
        text: '桌面商店图标显示的升级软件数字与应用商店中可升级软件数字不符？',
        desc:
          '如您此类情况或桌面有显示数字而软件商店中没有可升级软件。请您通过“我要反馈”提交问题和异常截图，我们会核实处理。',
      },
      {
        name: 'errorUpdate',
        text: '升级成功完成后，依然提示升级该软件',
        desc:
          '该问题可能是由于升级后注册表信息未更新导致的，请您通过“我要反馈”提交软件名称及版本和问题描述，我们会核实处理。',
      },
      {
        name: 'nothave',
        text: '本地并未安装此软件，但升级列表中出现此软件升级提示',
        desc:
          '您好，请您查看控制面板-卸载程序中是否有该软件？如果有该软件，请您使用geekuninstaller强制删除；如果没有该软件请您通过“我要反馈”提交软件名称及版本，我们会核实处理。',
      },
    ],
  },
  {
    name: 'uninstall',
    text: '卸载问题',
    child: [
      {
        name: 'other',
        text: '为什么运行了卸载程序依然无法卸载软件？',
        desc:
          '如果您运行了卸载程序依然无法卸载掉该软件，请您通过“我要反馈”提交软件名称及现象，我们会核实处理。',
      },
      {
        name: 'del',
        text: '为什么会进行强制删除？什么是强制删除？',
        desc:
          '您好，如果在商店执行卸载操作无法查找到卸载文件将进入强制删除流程，强制删除会将软件所安装目录文件夹下的所有文件进行清理。请了解。',
      },
      {
        name: 'otherdel',
        text: '为什么强制删除后将其他安装软件的文件也进行了删除？',
        desc:
          '您好，强制删除是针对安装目录文件夹进行全部清理，如果您将多个软件文件安装在相同目录文件夹下则有可能将其他软件的文件进行删除。请您谨慎操作。',
      },
      {
        name: 'errdel',
        text: '如果强制删除时误删除了其他软件，怎么办？',
        desc:
          '您好，如其他软件文件都在强制删除时被进行了删除，请卸载这些软件然后重新进行安装尝试。',
      },
    ],
  },
  {
    name: 'running',
    text: '运行问题',
    child: [
      {
        name: 'icon',
        text: '点击桌面应用商店快捷方式图标，点击后没有任何反应',
        desc:
          '如出现上述情况，请您右键查看软件商店图标的属性，查看“目标”内是否空白，如果是空白请您删除桌面快捷方式。然后通过联想电脑管家进入软件商店，再退出时重新创建快捷方式或联系客服QQ2881414005为您处理。',
      },
      {
        name: 'running_dealy',
        text: '页面加载速度慢',
        desc:
          '如应用商店中页面加载速度很慢，建议您重启路由或更换网络尝试。如依然很慢，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
    ],
  },
  {
    name: 'wallpaper',
    text: '壁纸问题',
    child: [
      {
        name: 'downloadwp',
        text: '壁纸是否可以下载？',
        desc: '您好，目前软件商店中开通壁纸订阅权益后所有壁纸都支持下载。',
      },
      {
        name: 'searchwp',
        text: '壁纸订单如何查询？',
        desc: '您好，壁纸订单不会出现在订单中心内，请您进入壁纸频道—我的壁纸—壁纸订单中进行查看。',
      },
      {
        name: 'wpcancellation',
        text: '壁纸会员如何取消自动续费？',
        desc:
          '您好，请您进入壁纸—我的—查看右上角是否有续费管理，如没有续费管理是没有开通自动续费的。另外，如果您是微信支付的会员，可以进入微信—我—服务—钱包—支付设置—自动续费检查是否有签约自动续费服务。最后，如果您是支付宝支付的会员，可以进入支付宝—我的—右上角“设置”—支付设置—自动扣款检查是否有签约自动续费服务。',
      },
      {
        name: 'whysearchwp',
        text: '为什么我购买的壁纸订单查看不到了？',
        desc:
          '您好，壁纸订单信息是与您购买的账号相关联的，请您确认登录的账号是否正确以及商店版本是否是8.5版本及以上。如账号无误，请联系客服QQ：2881414005提供支付订单截图帮您核实处理。',
      },
      {
        name: 'screen',
        text: '壁纸是否可以设置为锁屏？',
        desc: '抱歉，目前壁纸无法设置为锁屏，建议您可以开通壁纸订阅权益：下载壁纸后设置为锁屏。',
      },
      {
        name: 'isturn',
        text: '壁纸是否支持轮播形式？',
        desc:
          '您好，8.5版本商店上线壁纸轮播功能，您可以进行体验。开通壁纸订阅权益可以设置更多轮播内容',
      },
      {
        name: 'isreturnmoney',
        text: '开通壁纸订阅权益能否退款？',
        desc: '您好，壁纸订阅服务属于虚拟产品，无法进行退还，请您理解',
      },
      {
        name: 'collect',
        text: '如何查看曾经设置过的壁纸或收藏的壁纸？',
        desc: '您可以进入“壁纸”内“我的壁纸”查看已收藏或设置过的壁纸。',
      },
      {
        name: 'cancel',
        text: '如何取消已设置过的壁纸？',
        desc: '您可以在桌面点击鼠标右键进入“个性化”中切换回系统自带壁纸哦。',
      },
      {
        name: 'automatic',
        text: '如何关闭电脑自动更换锁屏壁纸的设置？',
        desc: '您可以进入联想电脑管家—工具箱—联想锁屏进行设置。',
      },
    ],
  },
  {
    name: 'apk',
    text: '联想模拟器',
    child: [
      {
        name: 'downloadsimulator',
        text: '为什么打开应用商店就安装联想模拟器？',
        desc:
          '您好，请您查看商店右上角的任务列表中是否有安卓应用的安装处于准备中的状态，请您等待联想模拟器安装完毕后将安卓应用下载安装任务完成再进行卸载操作。',
      },
      {
        name: 'what',
        text: '为什么要使用联想模拟器？模拟器有什么作用？',
        desc:
          '部分手机中的应用是无法在windows系统中直接运行的，需要模拟器为其提供android运行环境。例如：淘宝、快手等。',
      },
      {
        name: 'start',
        text: '联想模拟器在启动时进度条卡住，无法正常启动。',
        desc:
          '模拟器在启动时如卡住进度，请关闭或者卸载360一类的软件。然后退出模拟器之后再开，若仍然打不开请加入模拟器用户群：1074766324咨询',
      },
      {
        name: 'error',
        text: '联想模拟器画面出现卡顿、掉帧、花屏的情况。',
        desc:
          '如出现上述情况，请您进入右上角模拟器中“系统设置”。将“引擎”中的性能设置调整到更高同时切换渲染模式进行尝试。如依然无法解决，请您加入用户群：1074766324为您核实处理。',
      },
      {
        name: 'screen',
        text: '为什么联想模拟器看抖音只有声音，而视频是黑屏的？',
        desc:
          '请您在模拟器中将设置内的渲染模式进行下切换再次尝试。如果依然不行，请加入模拟器用户群：1074766324咨询',
      },
      {
        name: 'voice',
        text: '联想模拟器没有声音',
        desc:
          '如出现上述情况，请您进入右上角模拟器中“系统设置”。查看“设备”中声音播放设置是否正确。如依然没有音频输出，请您加入用户群：1074766324为您核实处理。',
      },
      {
        name: 'network',
        text: '联想模拟器无法联网',
        desc:
          '请您打开模拟器中浏览器输入百度的网址尝试是否可以打开。如果正常开启说明模拟器联网正常；如无法开启，请您将模拟器右上角“系统设置”—“网络”—“网络模式”修改为桥接。如依然无法解决，请您加入用户群：1074766324为您核实处理。',
      },
      {
        name: 'package',
        text: '联想模拟器如何安装外部的apk包？',
        desc: '您可以开启联想模拟器，然后将APK安装包直接拖入模拟器中进行安装。',
      },
      {
        name: 'export',
        text: '如何导出模拟器中的文件或导入电脑中文件？',
        desc:
          '您可以在联想模拟器右侧菜单栏中点击“更多”点击“共享”进入共享文件夹。点击安卓机器人图标进入模拟器中共享文件夹，将模拟器中需要导出的文件放入此文件夹，点击windows图标可以打开电脑中共享文件夹将文件取出即可。反之即可导入电脑中文件进模拟器。',
      },
      {
        name: 'running',
        text: '联想模拟器中应用出现停止运行情况',
        desc:
          '请您退出联想模拟器重新打开再次尝试应用是否可以正常运行。如果依然无法正常运行，请您加入用户群：1074766324为您核实处理。',
      },
    ],
  },

  {
    name: 'other',
    text: '其他问题',
    child: [
      {
        name: 'buy_question',
        text: '您在应用商店中购买的office、百度网盘会员、腾讯视频会员等有问题需要咨询？',
        desc: '商品购买问题请联系商城客服QQ：3195476850。我们会尽快回复您，帮助解决该问题。',
      },
      // {
      //   name: 'afterbuy',
      //   text: '联想版软件购买后如何退费？',
      //   desc:
      //     '您好，如果您是首次购买并且在购买后7天内，可通过应用商店昵称处进入“订单中心”在订单中心可以申请退费。',
      // },
      {
        name: 'drawback',
        text: '联想版软件申请退费后为什么等了几天还没到账？',
        desc:
          '您好，申请退费后我们的工作人员会在2-3个工作日完成退费操作，法定节假日是不算作工作日的，请您耐心等待。',
      },
      {
        name: 'nodrawback',
        text: '为什么无法申请联想版软件退费？',
        desc:
          '您好，联想版软件退费申请，同一用户仅享受一次7天无理由退款权益。请您确认是否此前进行过退费或超过7天时效。',
      },
      {
        name: 'buyorder',
        text: '为什么我进入订单中心无法查看到联想版软件购买订单？',
        desc:
          '您好，联想版软件购买订单需要在联想应用商店8.2版本以上才能查看，请您确认应用商店版本是否高于8.2版本，如果低于8.2版本请在lestore.lenovo.com网站下载安装最新版本商店。如版本高于8.2依然无法查看，请您确认登录账号是否为此前所购买软件的账号。如依然无法查看，请联系客服QQ：2881414005',
      },
      {
        name: 'bingdu',
        text: '下载安装第三方软件出现报病毒的情况',
        desc:
          '软件商店上架的软件均是经过人工审核的，并且通过各大主流杀毒软件检测通过的。如您遇到上述问题，请您通过“我要反馈”提交软件名称及杀毒软件名称，我们会核实处理。',
      },
      {
        name: 'comment',
        text: '评论被禁言',
        desc:
          '抱歉，如果您发布的评论内容中包含敏感字符或是广告信息是可能会被禁言的。如果您对禁言表示异议，请您通过“我要反馈”提交问题，我们会核实处理。',
      },
      {
        name: 'publish',
        text: '如何发布软件评论？',
        desc: '首先您需要在应用商店左下角登录您的账号，登录后软件详情页面即可评论。',
      },
      {
        name: 'reply',
        text: '如何查看别人回复的评论？',
        desc: '您好 请您进入应用商店右上角“消息中心”进行查看。',
      },
      {
        name: 'create',
        text: '如何创建桌面快捷方式打开软件商店？',
        desc:
          '在您退出软件商店时候我们会提示您创建桌面快捷方式。如果您无意关闭了此提示并且选择近期不再提醒，可以进入文件夹：C:Program Files (x86)LenovoLeAppStore找到LenovoAppStore.exe文件，右键创建快捷方式或发送到桌面快捷方式即可',
      },
    ],
  },
];
